import { METRIC_NAMES } from '@config/Consts';

class QueueHealthModel {
  constructor(options) {
    this.id = options.id;
    this[METRIC_NAMES.SKILL_UNASSIGNED_CONVERSATIONS] =
      options[METRIC_NAMES.SKILL_UNASSIGNED_CONVERSATIONS];
    this[METRIC_NAMES.CONVERSATION_IN_QUEUE_WAIT_TIME] =
      options[METRIC_NAMES.CONVERSATION_IN_QUEUE_WAIT_TIME];
    this[METRIC_NAMES.OVERDUE_ASSIGNED] =
      options[METRIC_NAMES.OVERDUE_ASSIGNED];
    this[METRIC_NAMES.OVERDUE_IN_QUEUE] =
      options[METRIC_NAMES.OVERDUE_IN_QUEUE];
    this[METRIC_NAMES.OVERDUE_TOTAL] =
      options[METRIC_NAMES.OVERDUE_TOTAL];
    this[METRIC_NAMES.SKILL_WAIT_TIME_AGENT_ASSIGNMENT_50_PERCENTILE] =
      options[METRIC_NAMES.SKILL_WAIT_TIME_AGENT_ASSIGNMENT_50_PERCENTILE];
    this[METRIC_NAMES.SKILL_WAIT_TIME_AGENT_ASSIGNMENT_90_PERCENTILE] =
      options[METRIC_NAMES.SKILL_WAIT_TIME_AGENT_ASSIGNMENT_90_PERCENTILE];
    this[METRIC_NAMES.ACTIONABLE] =
      options[METRIC_NAMES.ACTIONABLE];
  }
}

export default QueueHealthModel;
